/**
 * Admin user management API calls.
 */

import { api } from './client.js';

export function listUsers() {
  return api.get('/api/admin/users');
}

export function updateUserRole(userId, role) {
  return api.patch(`/api/admin/users/${userId}/role`, { role });
}

export function updateUserActive(userId, isActive) {
  return api.patch(`/api/admin/users/${userId}/active`, { is_active: isActive });
}
